import { render, staticRenderFns } from "./ItemKapufa.vue?vue&type=template&id=4ae234d4&scoped=true&"
import script from "./ItemKapufa.vue?vue&type=script&lang=js&"
export * from "./ItemKapufa.vue?vue&type=script&lang=js&"
import style0 from "./ItemKapufa.vue?vue&type=style&index=0&id=4ae234d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae234d4",
  null
  
)

export default component.exports